<template>
    <div id="ra-building-preference">
        <v-card-title class="pb-0">
            <v-icon :color="kingsGold" left>mdi-home-group</v-icon> Building Preference
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="pb-1 px-0">
                    <v-icon :color="kingsGold" left>mdi-home-group</v-icon>Building Preference (Please rank
                    three)
                </v-card-subtitle>
                <v-alert :color="infoColor" dense icon="mdi-information" text>
                    <b>Please note:</b>
                    <ul>
                        <li>
                            <b>Monsignor Wemple</b> residence is designated to female only.
                        </li>
                        <li>
                            Keep in mind that Managers will make placements based on the needs of the residence
                            program.
                        </li>
                    </ul>
                </v-alert>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-home-floor-1</v-icon>Building - First Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption01" label="Building Preference"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit01"
                            label="Please indicate which unit(s) you would prefer" placeholder="None" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner01"
                            label="Please indicate any preferred Residence Assistant partner" placeholder="None"
                            readonly>
                        </v-text-field>
                        <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionOneFile()" small tile
                            @click="getBuildingsOptionOneFileLink()">Download Contract Conditions
                        </v-btn>
                        <v-checkbox v-model="item.buildingContractCondition01" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-home-floor-2</v-icon>Building - Second Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption02" label="Building Preference"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit02"
                            label="Please indicate which unit(s) you would prefer" placeholder="None" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner02"
                            label="Please indicate any preferred Residence Assistant partner" placeholder="None"
                            readonly>
                        </v-text-field>
                        <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionTwoFile()" small tile
                            @click="getBuildingsOptionTwoFileLink()">Download Contract Conditions
                        </v-btn>
                        <v-checkbox v-model="item.buildingContractCondition02" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="px-0">
                            <v-icon :color="kingsGold" left>mdi-home-floor-3</v-icon>Building - Third Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption03" label="Building Preference"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit03"
                            label="Please indicate which unit(s) you would prefer" placeholder="None" readonly>
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner03"
                            label="Please indicate any preferred Residence Assistant partner" placeholder="None"
                            readonly>
                        </v-text-field>
                        <v-btn class="white--text" :color="infoColor" :disabled="getBuildingsOptionThreeFile()" small
                            tile @click="getBuildingsOptionThreeFileLink()">Download Contract Conditions
                        </v-btn>
                        <v-checkbox v-model="item.buildingContractCondition03" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.buildingUnitPreference" hide-details label="Unit Preference"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.residenceMealPlan"
                            hint="Note: These costs are approximate. Final costs are subject to Board approval."
                            label="Meal Plan" persistent-hint placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'ra-application-building-preference',
    props: {
        item: {
            required: true,
            type: Object
        },
        user: {
            required: true
        }
    },
    methods: {
        getBuildingsOptionOneFile() {
            let option = this.item.buildingOption01;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionOneFileLink() {
            let option = this.item.buildingOption01;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        getBuildingsOptionTwoFile() {
            let option = this.item.buildingOption02;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionTwoFileLink() {
            let option = this.item.buildingOption02;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
        getBuildingsOptionThreeFile() {
            let option = this.item.buildingOption03;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            if (building && building.fileContractConditions && building.fileContractConditions.file && building.fileContractConditions.fileNormalized) {
                return false;
            }

            return true;
        },
        getBuildingsOptionThreeFileLink() {
            let option = this.item.buildingOption03;
            let buildings = this.user.buildings || [];
            let building;

            if (option) {
                for (let i = 0; i < buildings.length; i++) {
                    if (option == buildings[i].name) {
                        building = buildings[i];
                        break;
                    }
                }
            }

            let data = JSON.stringify({
                file: building.fileContractConditions.file,
                fileNormalized: building.fileContractConditions.fileNormalized
            });

            window.open(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?download&data=${data}`);
        },
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>